
import { mapGetters } from 'vuex'
import register from '~/mixins/common/pages/register'
import checkApp from '~/mixins/pages/register/checkApp'
export default {
    name: 'Register',
    mixins: [register, checkApp],
    middleware: 'auth',
    computed: {
        ...mapGetters({
            getRegistrationSuspendByCurrency:
                'settings/getRegistrationSuspendByCurrency',
        }),
    },
    mounted() {
        if (
            this.getRegistrationSuspendByCurrency(
                this.$cookie.get('currency')
            ) === true
        ) {
            this.$router.push('/')
        }
    },
}
